import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Space, Tag, message,Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem, SegmentedItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

class WorkBenchRequisiciones extends Component {
  state = {
    idEditarRequisicion: null,
    modalAgregarFamilia: false,
    todasWorkBenchs: [],
    loading: false,
    valor: 1,
    requisicionesSeleccionadas: [],
    objetoRequisicionesEncontradas: []
  };
  componentDidMount() {
    this.consultarWorkBenchs(this.state.valor);
  }
  consultarWorkBenchs(valor) {
    this.setState({ loading: true });
    axios
      .post(
        "workbenchRequisiciones/selectTodasWorkBenchs",
        { empresaId: this.props.empresaId, valor: valor },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          this.setState({ todasWorkBenchs: [] });
        } else {
          this.setState({
            todasWorkBenchs: res.data.map((data) => {
              return {
                ...data,
                accion: {
                  estado: data.estado,
                  _id: data._id,
                },
                proyecto: data.proyecto.nombre,
                proveedorNombre: data?.proveedor?.nombre ? ((data?.proveedor?.nombre || "") + " " + (data?.proveedor?.apellidoPaterno || "") + " " + (data?.proveedor?.apellidoMaterno || ""))
                  : (data?.proveedor?.razonSocial || ""),
              };
            }),
          });
        }
      });
  }

  deshabilitarWorkBenchRequisicion(value) {
    axios
      .post(
        "workbenchRequisiciones/deshabilitarWorkBenchRequisicion",
        { requisicionId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("WorkBench deshabilitada correctamente");
        } else if (res.data.success === 1) {
          message.warning(res.data.message ? res.data.message : "Hubo un error");
        } else {
          message.error("Sucedio un error y no se pudo deshabilitar");
        }
        this.consultarWorkBenchs(this.state.valor);
      });
  }

  habilitarWorkBenchRequisicion(value) {
    axios
      .post(
        "workbenchRequisiciones/habilitarWorkBenchRequisicion",
        { requisicionId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("WorkBench habilitada correctamente");
        } else if (res.data.success === 1) {
          message.warning(res.data.message ? res.data.message : "Hubo un error");
        } else {
          message.error("Sucedio un error y no se pudo habilitar");
        }
        this.consultarWorkBenchs(this.state.valor);
      });
  }

  agregarWorkBenchRequisicion() {
    this.props.history.push("/panel/agregarRequisicion", { workbench: true });
  }
  editarWorkBenchRequisicion(id) {
    this.props.history.push("/panel/editarRequisicion", { id, workbench: true });
  }
  generarOrdenDeCompra(id) {
    this.props.history.push("/panel/generarOrdenDeCompraConRequisicion", { id, workbench: true });
  }
  mandarWorkBench(id) {
    this.props.history.push("/panel/mandarWorkBench", { id, workbench: true });
  }

  render() {
    const columns = [
      {
        title: "Numero",
        dataIndex: "numero",
        key: "numero",
        render: (value, record) => `${record.serie || "M"} ${value}`,
        buscar: "numero",
        width: "5%",
      },
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        sorter: (a, b) => {
          if (moment(a.createdAt) < moment(b.createdAt)) {
            return -1;
          }
          if (moment(a.createdAt) > moment(b.createdAt)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('L'),
        width: '10%',
      },
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        key: "proveedorNombre",
        sorter: (a, b) => {
          if (a.proveedorNombre < b.proveedorNombre) {
            return -1;
          }
          if (a.proveedorNombre > b.proveedorNombre) {
            return 1;
          }
          return 0;
        },
        buscar: "proveedorNombre",
        width: "15%",
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto < b.proyecto) {
            return -1;
          }
          if (a.proyecto > b.proyecto) {
            return 1;
          }
          return 0;
        },
        buscar: "proyecto",
        width: "15%",
      },
      {
        title: "Observaciones",
        dataIndex: "observaciones",
        key: "observaciones",
        sorter: (a, b) => {
          if (a.observaciones < b.observaciones) {
            return -1;
          }
          if (a.observaciones > b.observaciones) {
            return 1;
          }
          return 0;
        },
        buscar: "observaciones",
        width: "35%",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        render: (value, index) => {
          if (value === 0) {
            return <Tag color="red">Cancelada</Tag>;
          }
          if (value === 1) {
            return <Tag color="green">Activa</Tag>;
          }
          if (value === 2) {
            return <Tag color="red">Deshabilitada</Tag>;
          }
          if (value === 3) {
            return <Tag color="green">Terminada</Tag>;
          }
        },
        width: "10%",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        render: (value, index) => (
          <Space size="small">
            {(value.estado === 1 || value.estado === 2) ?
            <Tooltip title="Generar O.Compra WB" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="primary"
                size="small"
                naranja
                onClick={() => this.generarOrdenDeCompra(value._id)}
              >
                G
              </ButtonItem>
              </Tooltip>
              : null}
            {((value.estado === 1 || value.estado === 2) && (this.props.workbenchRequisiciones)) ?
            <Tooltip title="Mandar a WorkBench" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
             <ButtonItem
                type="primary"
                size="small"
                blanco
                onClick={() => this.mandarWorkBench(value._id)}
              >
                W
              </ButtonItem>
              </Tooltip>
              : null}
            {value.estado === 1 ? (
              <>
                <Tooltip title="Editar Workbench" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`editar-${index}`}
                    type="default"
                    size="small"
                    cyan
                    icon={<EditOutlined />}
                    onClick={() => this.editarWorkBenchRequisicion(value._id)}
                  />
                </Tooltip>
                <Tooltip title="Deshabilitar Workbench" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <Popconfirm
                    title="Seguro que quieres deshabilitar este Workbench"
                    onConfirm={() => this.deshabilitarWorkBenchRequisicion(value._id)}
                    okText="Si"
                    cancelText="No"
                    key={index.toString()}
                  >
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    />
                  </Popconfirm>
                </Tooltip>
              </>
            ) : null}
            {value.estado === 2 ? (
              <>
                <Tooltip title="Habilitar Workbench" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <Popconfirm
                    title="Seguro que quieres habilitar este Workbench"
                    onConfirm={() => this.habilitarWorkBenchRequisicion(value._id)}
                    okText="Si"
                    cancelText="No"
                    key={index.toString()}
                  >
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    />
                  </Popconfirm>
                </Tooltip>
              </>
            ) : null}
          </Space>
        ),
        width: "20%",
      },
    ];
    return (
      <>
        <PageHeader
          title="WorkBench Requisiciones"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Activas', value: 1 }, { label: 'Deshabilitado', value: 2 }, { label: 'Todos', value: 5 }]}
                  onChange={(value) => {
                    this.consultarWorkBenchs(value)
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              <ButtonItem
                type="primary"
                olivo
                key="agregarWorkBenchRequisicion"
                onClick={this.agregarWorkBenchRequisicion.bind(this)}
                className="botonAgregar"
              >
                Agregar WorkBench Requisición
              </ButtonItem>
            </>
          }
        />
        <TableItem
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasWorkBenchs}
          columns={columns}
          pagination={false}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })} 
          onRow={(record) => ({
            onDoubleClick: () => {
              this.editarWorkBenchRequisicion(record.accion._id);
            },
          })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    workbenchRequisiciones: state.empresa.workbenchRequisiciones,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(WorkBenchRequisiciones);
